import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  IconButton,
  Spinner,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
//@ts-ignore
import Mazemap from "@itpi/mazemap";
import Map from "../../components/Map";
import { BusTime, useBusStop } from "../../data/buses.api";
import { useFocusOnLngLat } from "../../hooks/useFocusOnLngLat";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import BusStopHeading from "../../components/buses/BusStopHeading";
import BusTimes from "../../components/buses/BusTimes";
import BackButton from "../../components/BackButton";
import FavouriteButton from "../../components/FavouriteButton";

const BusStopInformation = () => {
  const { atcoCode } = useParams<{ atcoCode: string }>();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useBusStop(atcoCode);

  const busStopLocation = useMemo(() => {
    if (data)
      return {
        lat: parseFloat(data.latitude),
        lng: parseFloat(data.longitude),
      };
  }, [data]);

  useFocusOnLngLat(busStopLocation?.lng, busStopLocation?.lat);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />
      <Box p={8}>
        {isError ? (
          <Flex
            my={10}
            justify="center"
            alignItems="center"
            gap={4}
            direction="column"
          >
            <Heading size="lg">Bus stop not found</Heading>
            <Button as={Link} to="/">
              Go back home
            </Button>
          </Flex>
        ) : isLoading ? (
          <Flex my={10} justify="center" alignItems="center">
            <Spinner size="lg" />
          </Flex>
        ) : data ? (
          <Box>
            <Flex justify="space-between">
              <BusStopHeading size="md" busStop={data} mb={4} />
              <FavouriteButton
                name={
                  `${data.commonName}` +
                  (data.identifier.toLowerCase().startsWith("stand")
                    ? `${data.identifier}`
                    : "")
                }
              />
            </Flex>
            <BusTimes
              atcoCode={data.atcoCode}
              showScheduledTime
              onClick={(busTime) =>
                navigate(
                  `/buses/${
                    busTime.atcocode
                  }/route?aimedDepartureTime=${encodeURIComponent(
                    busTime.aimedDepartureTime
                  )}&operator=${busTime.operator}&line=${busTime.line}&dir=${
                    busTime.dir
                  }&dest=${encodeURIComponent(busTime.destinationName)}`
                )
              }
            />
          </Box>
        ) : null}
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default BusStopInformation;
